import type { ExcelColumnMapping } from './types';

export const BANG_CAN_DOI_PHAT_SINH_CONG_NO_COLUMNS: ExcelColumnMapping[] = [
  { header: 'Tài khoản', width: 12, resolver: row => row.tk ?? '' },
  { header: 'Mã khách hàng', width: 18, resolver: row => row.ma_kh ?? '' },
  { header: 'Tên khách hàng', width: 30, resolver: row => row.ten_kh ?? '' },
  { header: 'Dư nợ đầu', width: 18, resolver: row => Number(row.no_dk ?? 0) },
  { header: 'Dư có đầu', width: 18, resolver: row => Number(row.co_dk ?? 0) },
  { header: 'Ps nợ', width: 18, resolver: row => Number(row.ps_no ?? 0) },
  { header: 'Ps có', width: 18, resolver: row => Number(row.ps_co ?? 0) },
  { header: 'Dư nợ cuối', width: 18, resolver: row => Number(row.no_ck ?? 0) },
  { header: 'Dư có cuối', width: 18, resolver: row => Number(row.co_ck ?? 0) }
];
